// extracted by mini-css-extract-plugin
export var hideEditor = "_kr-2";
export var infoIcon = "_kr-3";
export var label = "_kr-1";
export var labelContainer = "_kr-0";
export var readonlyText = "_kr-4";